<template>
  <v-container v-if="emailSettings.length">
    <v-layout wrap>
      <v-flex xs6 pa-2>
        <div v-for="(email, index) in emailSettings" :key="index">
          <v-layout wrap v-if="email.perspective === 'outbound'">
            <v-flex xs12>
              {{ email.description }}
              <EmailSelector
                :selected-emails.sync="email.from"
                :email-index="index"
                :multiple="false"
                :pricing-option="false"
                :event="email.event"
                :readonly="!canUpdateEmailSetting"
              />
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
      <v-flex xs6 pa-2>
        <div v-for="(email, index) in emailSettings" :key="index">
          <v-layout wrap v-if="email.perspective === 'inbound'">
            <v-flex xs12>
              {{ email.description }}
              <EmailSelector
                :selected-emails.sync="email.to"
                :email-index="index"
                :event="email.event"
                multiple
                pricing-option
              />
            </v-flex>
          </v-layout>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import request from "@/modules/request";
import EmailSelector from "@/components/shared/EmailSelector";
import { hasPermission } from "@/modules/rbac/permission-manifest";

export default {
  name: "EmailSettings",
  inject: ["snackBar", "reactiveInjected"],
  async mounted() {
    await this.getClientConfiguration();
  },
  components: {
    EmailSelector,
  },
  data() {
    return {
      settings: null,
      emailSettings: [],
      search: {
        email: null,
        includePricing: false,
      },
      items: [{ header: "Select an option or create one" }],
      canUpdateEmailSetting: hasPermission(
        "canUpdateEmailSetting",
        null,
        this.reactiveInjected.activeUser
      ),
    };
  },
  watch: {
    emailSettings: {
      handler(val) {
        this.save();
      },
      deep: true,
    },
  },
  methods: {
    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");
      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    async save() {
      await request
        .callInternal({
          method: "patch",
          route: "/api/admin/client",
          data: {
            emailConfigurations: this.emailSettings,
          },
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async getClientConfiguration() {
      const results = await request.callInternal({
        method: "get",
        route: "/api/admin/emailsettings",
      });
      this.emailSettings = results.data;
    },
  },
};
</script>
